import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import Modal from "../../shared/modal";
import TemplateFormInputs from "../taskTemplates/templateFormInputs";
import TaskService from "../../../services/TaskService";
import ActionPlanUseWarning from "./actionPlanUseWarning";
export class TemplateModal extends Component {
    // eslint-disable-line max-len
    constructor(props) {
        super(props);
        this.handleAddTemplate = () => {
            const validation = TaskService.validateTaskTemplate(Object.assign(Object.assign({}, this.props.template), this.state.templateChanges), true);
            if (!validation.isValid) {
                this.setState({
                    hasError: true,
                    errorMessage: validation.errorMessage,
                });
            }
            else {
                this.props.onTemplateSubmit(Object.assign(Object.assign({}, this.props.template), this.state.templateChanges));
            }
        };
        this.clearStateAndCallCloseModalHandler = () => {
            this.setState({
                errorMessage: "",
                hasError: false,
                templateChanges: {},
            });
            this.props.onCloseModal();
        };
        this.state = {
            templateChanges: {},
            hasError: false,
            errorMessage: "There was an error adding that task template",
        };
    }
    render() {
        return (_jsx(Modal, { onCloseModal: this.clearStateAndCallCloseModalHandler, isOpen: this.props.isModalOpen, modalId: this.props.modalId, keyboard: false, children: _jsx("div", { className: "modal-dialog  modal-lg", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsx("div", { className: "modal-header", children: this.props.modalHeader }), _jsxs("div", { className: "modal-body", children: [this.props.template &&
                                    TaskService.getNumberOfActionPlansTemplateUsedIn(this.props.template, new Set(this.props.actionPlanTemplate &&
                                        this.props.actionPlanTemplate.id
                                        ? [this.props.actionPlanTemplate.id]
                                        : [])) !== 0 && (
                                // @ts-expect-error - TS2322 - Type 'TaskTemplateUsages | undefined' is not assignable to type 'TaskTemplateUsages'.
                                _jsx(ActionPlanUseWarning, { usages: this.props.template.usages })), _jsx(TemplateFormInputs, { isForTemplateInActionPlan: true, template: Object.assign(Object.assign({}, this.props.template), this.state.templateChanges), onTemplateChange: (change) => this.setState({
                                        templateChanges: Object.assign(Object.assign({}, this.state.templateChanges), change),
                                    }) }), this.state.hasError && (_jsx("div", { className: "alert alert-danger", children: "Could not add template. " + this.state.errorMessage }))] }), _jsxs("div", { className: "modal-footer", children: [this.props.submitButton(this.handleAddTemplate), _jsx("button", { type: "button", className: "btn btn-outline-dark", onClick: this.props.onCloseModal, children: "Cancel" })] })] }) }) }));
    }
}
